
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTargetCancelAllIec as ObiTargetCancelAllIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-target-cancel-all-iec.js';
 
 
 

 
 export const ObiTargetCancelAllIec = createComponent({
   react: React,
   tagName: 'obi-target-cancel-all-iec',
   elementClass: ObiTargetCancelAllIecElement,
   events: {
     
   }
  });
 
 